module.exports = __webpack_public_path__ + "img/bow tapered angle.73872a7b.png";